import { IListItem } from '@nkr/models/index';
import { Col, ControlLabel, Form, FormControl, FormGroup } from 'react-bootstrap';
import { RowWrapper } from './styles';
import MaskedInput from 'react-maskedinput';
import { IValidation } from './validation';
import { FormEvent } from 'react';

interface IProps {
    firstName: string,
    lastName: string,
    birthDate: string,
    donationType: number,
    transplantDate: string,
    isUpdate: boolean,
    isDirty: boolean,
    validation: IValidation,
    donationTypes: IListItem[],
    onUpdate: (property: string, value: any) => void
}

const EntryContent = (props: IProps) => {
    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        props.onUpdate(name, value);
    };

    const { firstName, lastName, birthDate, donationType, transplantDate, isDirty, validation } = props;

    return (
        <Form horizontal>
            <RowWrapper>
                <Col xs={12} lg={4}>
                    <FormGroup validationState={isDirty && !validation.firstName ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>First Name:&nbsp;</Col>
                        <Col xs={12} lg={8}>
                            {props.isUpdate == false ?
                                <FormControl
                                    name='firstName'
                                    value={firstName}
                                    onChange={handleFieldChange}
                                />
                                :
                                <div className='form-control-static'>{firstName}</div>
                            }
                        </Col>
                    </FormGroup>
                </Col>

                <Col xs={12} lg={4}>
                    <FormGroup validationState={isDirty && !validation.lastName ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Last Name:&nbsp;</Col>
                        <Col xs={12} lg={8}>
                            {props.isUpdate == false ?
                                <FormControl
                                    name='lastName'
                                    value={lastName}
                                    onChange={handleFieldChange}
                                />
                                :
                                <div className='form-control-static'>{lastName}</div>
                            }
                        </Col>
                    </FormGroup>
                </Col>
                {/* </RowWrapper>

            <RowWrapper> */}
                <Col xs={12} lg={4}>
                    <FormGroup validationState={isDirty && !validation.birthDate ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Birth Date:&nbsp;</Col>
                        <Col xs={12} lg={8}>
                            {props.isUpdate == false ?
                                <MaskedInput
                                    name='birthDate'
                                    mask='11/11/1111'
                                    className='form-control'
                                    value={birthDate}
                                    onChange={handleFieldChange}
                                />
                                :
                                <div className='form-control-static'>{birthDate}</div>
                            }
                        </Col>
                    </FormGroup>
                </Col>
            </RowWrapper>

            <RowWrapper>
                <Col xs={12} lg={6}>
                    <FormGroup validationState={isDirty && !validation.donationType ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Donation Type:&nbsp;</Col>
                        <Col xs={12} lg={8}>
                            <FormControl
                                componentClass='select'
                                name='donationType'
                                value={donationType}
                                onChange={handleFieldChange}
                            >
                                <option value={0}>- Select -</option>
                                {props.donationTypes.map(item =>
                                    <option value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>
                </Col>

                <Col xs={12} lg={6}>
                    <FormGroup validationState={isDirty && !validation.transplantDate ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Transplant Date:&nbsp;</Col>
                        <Col xs={12} lg={8}>
                            <MaskedInput
                                name='transplantDate'
                                mask='11/11/1111'
                                className='form-control'
                                value={transplantDate}
                                onChange={handleFieldChange}
                            />
                        </Col>
                    </FormGroup>
                </Col>
            </RowWrapper>
        </Form>
    );
}

export default EntryContent;